import en from '../strings/lang/en';
var cap = 'customer assistance plan';
var questionnaire = 'questionnaire';
export var dchPlan = 'dch cap';
export var planAnalytics = {
    planStart: { pageFunction: cap, pageName: 'start' },
    settlementOptions: {
        pageFunction: cap,
        pageName: 'plan selection'
    },
    CAPE001: {
        pageFunction: cap,
        pageName: questionnaire,
        pageSubFunction: 'life changes'
    },
    CAPE002: {
        pageFunction: cap,
        pageName: questionnaire,
        pageSubFunction: 'source of income'
    },
    CAPE003: {
        pageFunction: cap,
        pageName: questionnaire,
        pageSubFunction: 'willing to close account'
    },
    CAPE004: {
        pageFunction: cap,
        pageName: questionnaire,
        pageSubFunction: 'income reduced'
    },
    CAPE005: {
        pageFunction: cap,
        pageName: questionnaire,
        pageSubFunction: 'increased your expenses'
    },
    CAPE006: {
        pageFunction: cap,
        pageName: questionnaire,
        pageSubFunction: 'how long impacted'
    },
    CAPE007: {
        pageFunction: cap,
        pageName: questionnaire,
        pageSubFunction: 'how long situation will last'
    },
    CAPE008: {
        pageFunction: cap,
        pageName: questionnaire,
        pageSubFunction: 'reduced monthly payments'
    },
    capPlanReview: {
        pageFunction: cap,
        pageName: 'plan review',
        message: en.common.confirmEnrollBannerText
    },
    capPlanConfirm: {
        pageFunction: cap,
        pageName: 'confirmation',
        message: en.common.confirmEnrollBannerText
    },
    capPlanSuccess: {
        pageFunction: cap,
        pageName: 'enrollment success',
        message: en.plan.successHeading
    },
    capOtherPaymentOptions: {
        pageFunction: cap,
        pageName: 'not eligible',
        message: en.settlement.contactHeading
    },
    planError: {
        pageFunction: cap,
        pageName: 'error',
        errorMessage: en.common.errorHeading
    },
    planForbearance: {
        pageFunction: cap,
        pageName: 'short term forbearance',
        message: en.plan.forbearanceHeading
    },
    leaving: {
        pageFunction: cap,
        pageName: 'not eligible:exit confirmation',
        errorMessage: en.settlement.contactHeading
    }
};
//# sourceMappingURL=planAnalytics.js.map